import React from 'react';
import { Link } from 'react-router-dom';

const BlogsPage = () => {
  const blogs = [
    {
      id: 1,
      title: 'CUET PG 2025: Your Comprehensive Guide to Success',
      slug: 'cuet-pg-2025-comprehensive-guide',
      excerpt: 'Everything you need to know about CUET PG 2025 - eligibility, syllabus, preparation strategies, and expert tips for success.',
      date: 'January 10, 2025',
      category: 'CUET PG',
      readTime: '8 min read',
      image: '/blog-images/cuet-pg-guide.jpg'
    },
    {
      id: 2,
      title: 'CUET PG History Question Paper: Download with Answer Key PDF',
      slug: 'cuet-pg-history-question-paper',
      excerpt: 'Download previous year CUET PG History question papers with detailed answer keys and solutions.',
      date: 'January 8, 2025',
      category: 'Question Papers',
      readTime: '5 min read',
      image: '/blog-images/history-papers.jpg'
    },
    {
      id: 3,
      title: 'How to prepare for CUET PG English Literature',
      slug: 'prepare-cuet-pg-english-literature',
      excerpt: 'A complete preparation guide for CUET PG English Literature with recommended books, study plan, and important topics.',
      date: 'January 5, 2025',
      category: 'Preparation Tips',
      readTime: '10 min read',
      image: '/blog-images/english-literature.jpg'
    },
    {
      id: 4,
      title: 'CUET PG Online Coaching: Ace Your Exam with the Right Preparation',
      slug: 'cuet-pg-online-coaching',
      excerpt: 'Discover how online coaching can help you crack CUET PG with flexible learning options and expert guidance.',
      date: 'January 2, 2025',
      category: 'Online Learning',
      readTime: '6 min read',
      image: '/blog-images/online-coaching.jpg'
    }
  ];

  return (
    <div className="min-h-screen pt-32 pb-20">
      <div className="max-w-[1400px] mx-auto px-8">
        {/* Page Header */}
        <div className="text-center mb-16">
          <div className="hero-badge mx-auto mb-6">
            📚 Knowledge Hub
          </div>
          <h1 className="text-4xl lg:text-5xl font-extrabold gradient-text mb-6">
            BESST Blogs
          </h1>
          <p className="text-xl text-text-muted max-w-2xl mx-auto">
            Stay updated with the latest insights, preparation tips, and study guides for CUET and competitive exams.
          </p>
        </div>

        {/* Blog Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
          {blogs.map((blog) => (
            <article 
              key={blog.id}
              className="glass-card group hover:border-accent-gold/50 transition-all duration-300"
            >
              {/* Blog Image Placeholder */}
              <div className="h-48 bg-gradient-to-br from-primary/20 to-accent-gold/20 rounded-xl mb-6 flex items-center justify-center overflow-hidden">
                <div className="text-6xl opacity-50 group-hover:scale-110 transition-transform duration-300">
                  📖
                </div>
              </div>

              {/* Category & Date */}
              <div className="flex items-center gap-4 mb-4">
                <span className="px-3 py-1 bg-primary/20 text-primary rounded-full text-sm font-medium">
                  {blog.category}
                </span>
                <span className="text-text-muted text-sm">{blog.date}</span>
                <span className="text-text-muted text-sm">• {blog.readTime}</span>
              </div>

              {/* Title */}
              <h2 className="text-xl font-bold text-text-light mb-4 group-hover:text-accent-gold transition-colors">
                <Link to={`/blog/${blog.slug}`}>
                  {blog.title}
                </Link>
              </h2>

              {/* Excerpt */}
              <p className="text-text-muted mb-6 line-clamp-2">
                {blog.excerpt}
              </p>

              {/* Read More Link */}
              <Link 
                to={`/blog/${blog.slug}`}
                className="inline-flex items-center gap-2 text-primary hover:text-accent-gold font-medium transition-colors group/link"
              >
                Read More
                <svg 
                  className="w-4 h-4 transform group-hover/link:translate-x-1 transition-transform" 
                  fill="none" 
                  stroke="currentColor" 
                  viewBox="0 0 24 24"
                >
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
                </svg>
              </Link>
            </article>
          ))}
        </div>

        {/* Newsletter Section */}
        <div className="mt-20 glass-card text-center">
          <h3 className="text-2xl font-bold text-text-light mb-4">
            Subscribe to Our Newsletter
          </h3>
          <p className="text-text-muted mb-6 max-w-xl mx-auto">
            Get the latest articles, study tips, and exam updates delivered straight to your inbox.
          </p>
          <form className="flex flex-col sm:flex-row gap-4 max-w-md mx-auto">
            <input
              type="email"
              placeholder="Enter your email"
              className="flex-1 px-4 py-3 bg-bg-secondary border border-glass-border rounded-xl text-text-light focus:outline-none focus:border-primary transition-colors"
            />
            <button
              type="submit"
              className="btn-primary whitespace-nowrap"
            >
              Subscribe
            </button>
          </form>
        </div>
      </div>
    </div>
  );
};

export default BlogsPage;
